'use client'
import { config } from '@/configs/configPortal';
import { handleDispatchInteractionEvent } from '@/helpers/adobe';
import { capitalize } from '@/helpers/utils';
import Image from 'next/image';
import Link from 'next/link';
import './similar-models.scss';

type SimilarModelsProps = {
    vehicleType: string;
    models: {
        year_model: number;
        updated_date: string;
        image_url: string;
        brand: string;
        model: string;
        version: string;
        brand_slug: string;
        model_slug: string;
        version_slug: string;
        price: number;
    }[];
};

const SimilarModels = ({ models, vehicleType }: SimilarModelsProps) => {

    return (
        <div className="similar-models" data-testid="similar-models">
            <h2 data-testid="similar-models-title">Tabela de modelos similares</h2>
            <div className='similar-models__d-flex' data-testid="similar-models-container">
                <div className="similar-models__content" id="similar-models-content">
                    {models.map((model) => (
                        <Link
                            href={`${config.urlTableFipe}/${vehicleType}/${model.brand_slug}/${model.model_slug}`}
                            key={model.model_slug}
                            data-testid={`similar-model-link-${model.model_slug}`}
                            onClick={() => handleDispatchInteractionEvent('modelos-similares-resultado')}
                            className="similar-models__card__link"
                        >
                            <div className="similar-models__card" id={`similar-model-card-${model.model_slug}`}>
                                <div className="similar-models__card__image" data-testid={`similar-model-image-${model.model_slug}`}>
                                    <Image src={
                                        model.image_url
                                            ? model.image_url
                                            : `${process.env.NEXT_PUBLIC_ASSETS_PATH}/assets/img/car_default.svg`
                                    } alt={`${model.brand} ${model.model}`} width={166} height={124} loading='lazy' />
                                </div>
                                <div className="similar-models__card__title" data-testid={`similar-model-title-${model.model_slug}`}>
                                    {capitalize(model.brand_slug)} <b>&nbsp;{capitalize(model.model_slug)}</b>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SimilarModels;
